module.exports = __webpack_public_path__ + "img/C04TechGalley3_ua.64ea7d88.webp";